import type { NavigationView } from '@/shared/constants/navigation-view.enum';
import {
  getNavigationMenuForView,
  isNavMenuDivider,
  type NavMenuItem,
} from '@/shared/navigation/navigation-menu.config';
import type { NavigationPermissions } from '@/shared/navigation/navigation-permissions.utils';
import { resolveProfileHomeGroupDescription } from './profile-home-descriptions.utils';

export type ProfileHomeItem = {
  label: string;
  description: string;
  to: string;
};

const EXCLUDED_MENU_GROUPS = new Set(['Sistema']);

export function getProfileHomeItems(
  view: NavigationView,
  permissions: NavigationPermissions,
): ProfileHomeItem[] {
  const sections = getNavigationMenuForView(view, permissions);
  const items: ProfileHomeItem[] = [];
  const seen = new Set<string>();

  for (const section of sections) {
    for (const group of section.groups) {
      if (EXCLUDED_MENU_GROUPS.has(group.label)) continue;
      if (seen.has(group.label)) continue;

      const firstItem = group.items.find(
        (entry) => !isNavMenuDivider(entry),
      ) as NavMenuItem | undefined;
      if (!firstItem) continue;

      seen.add(group.label);
      items.push({
        label: group.label,
        description: resolveProfileHomeGroupDescription(group.label),
        to: firstItem.to,
      });
    }
  }

  return items;
}
